<fgb-banner [pageTitle]="'gallery.page.title' | translate" *ngIf="isGalleryPage"></fgb-banner>
<div class="img-banner-container d-none d-lg-block" role="banner" *ngIf="isWorksheetPage">
  <div class="container">
    <img [src]="'banner-images/worksheets-banner.png' | contentAssetImage" alt="kid banner" class="w-100" />
  </div>
</div>

<fgb-page-header
  [pageTitle]="isGalleryPage ? 'gallery.page.title' : 'worksheet.page.title'"
  [showBalance]="false"
  [showFooter]="isWorksheetPage"
  [backButtonLink]="'/'"
>
  <ng-template>
    <div class="pb-3" [ngClass]="{ 'd-none': isGalleryPage }">
      <img [src]="'banner-images/worksheets-banner.png' | contentAssetImage" alt="kid banner" class="w-100 rounded" />
    </div>
  </ng-template>
</fgb-page-header>
<div class="page-padding">
  <fgb-worksheet-list [isGalleryPage]="isGalleryPage" [isWorksheetPage]="isWorksheetPage"></fgb-worksheet-list>
</div>
